import './FaarmLogo.scss';
import classNames from 'classnames';

export function FaarmLogo({ className }: { className?: string }) {
    return (
        <svg
            id="FaarmLogo"
            className={classNames('FaarmLogo', className)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 500 109.33"
        >
            <g className="FaarmLogo__mark">
                <path
                    d="M30.54,58.8v35.27c0,8.42-6.85,15.26-15.27,15.26S0,102.49,0,94.07v-35.27c0-8.42,6.84-15.27,15.26-15.27s15.27,6.85,15.27,15.27Z"
                    fill="currentColor"
                />
                <path
                    d="M74.17,46.59v12.44c0,8.6-7,15.59-15.59,15.59h-11.91c-1.67,0-3.03-1.36-3.03-3.03v-12.46c0-8.59,6.99-15.59,15.59-15.59h11.89c1.69,0,3.06,1.37,3.06,3.06Z"
                    fill="currentColor"
                />
                <path
                    d="M101.6,15.27c0,8.42-6.85,15.26-15.27,15.26H15.26C6.84,30.54,0,23.69,0,15.27S6.84,0,15.26,0h71.07c8.42,0,15.27,6.85,15.27,15.27Z"
                    fill="currentColor"
                />
            </g>
            <g className="FaarmLogo__type">
                <path
                    d="M145.51,95.71h17.55c.34,0,.61-.27.61-.61v-31.11c0-.34.27-.61.61-.61h33.41c.34,0,.61-.27.61-.61v-16.47c0-.34-.27-.61-.61-.61h-33.41c-.34,0-.61-.27-.61-.61v-14.64c0-.34.27-.61.61-.61h41.41c.34,0,.61-.27.61-.61V12.77c0-.34-.27-.61-.61-.61h-60.18c-.34,0-.61.27-.61.61v82.34c0,.34.27.61.61.61Z"
                    fill="currentColor"
                />
                <path
                    d="M277.77,95.17l-.31-.31c-.25-.26-.5-.52-.74-.79-7.06-7.66-10.94-18.05-10.94-29.24,0-9.31,2.69-18.06,7.66-25.15.08-.09.11-.22.11-.33v-4.79c0-.33-.27-.6-.6-.6h-16.47c-.33,0-.6.27-.6.6v4.14c0,.53-.64.8-1.04.43-4.61-4.22-10.64-6.62-17.62-6.62-16.95,0-29.79,13.92-29.79,32.32s12.84,32.34,29.79,32.34c8.29,0,15.21-3.48,20.15-9.14.28-.32.77-.26.99.1,2.89,5.05,8.34,7.58,16.4,7.58h2.7c.19-.05.33-.23.33-.43,0-.05-.01-.08-.02-.11ZM240.17,80.09c-8.3-.28-14.43-6.73-14.43-15.25s6.42-15.25,15.01-15.25,14.83,6.23,15.13,14.63c.31,8.75-6.95,16.18-15.71,15.88Z"
                    fill="currentColor"
                />
                <path
                    d="M346.56,78.64c-1.54,0-2.93-.63-3.94-1.63-1-1.01-1.63-2.4-1.63-3.95v-38.5c0-.33-.27-.6-.6-.6h-16.47c-.33,0-.6.27-.6.6v4.14c0,.53-.64.8-1.04.43-4.61-4.22-10.64-6.62-17.61-6.62-16.96,0-29.79,13.92-29.79,32.32,0,4.97.93,9.62,2.65,13.74.61,1.55,1.35,3.02,2.2,4.4,5.22,8.67,14.26,14.19,24.94,14.19,8.27,0,15.21-3.48,20.13-9.14.28-.32.77-.26.99.1,2.89,5.05,8.34,7.58,16.41,7.58h4.35c.34,0,.61-.27.61-.61v-15.85c0-.33-.27-.6-.61-.6ZM307.6,80.09c-8.3-.28-14.43-6.73-14.43-15.25s6.42-15.25,15.01-15.25,14.83,6.23,15.13,14.63c.31,8.75-6.95,16.18-15.71,15.88Z"
                    fill="currentColor"
                />
                <path
                    d="M373.28,40.88v-6.31c0-.34-.27-.61-.61-.61h-16.46c-.34,0-.61.27-.61.61v60.54c0,.34.27.61.61.61h16.46c.34,0,.61-.27.61-.61v-28.21c0-9.56,6.66-15.74,18.64-15.74h1.82c.34,0,.61-.27.61-.61v-16.95c0-.34-.27-.61-.61-.61h-1.82c-6.95,0-12.98,3.02-17.59,8.29-.37.42-1.06.15-1.06-.4Z"
                    fill="currentColor"
                />
                <path
                    d="M477.6,32.51c-8.54,0-15.38,3.27-20.3,9.38-.26.32-.75.3-.98-.05-3.83-5.86-10.41-9.33-18.68-9.33-6.52,0-12.09,2.08-16.54,6.25-.38.36-1.01.07-1.01-.46v-3.74c0-.34-.27-.61-.61-.61h-16.46c-.34,0-.61.27-.61.61v60.54c0,.34.27.61.61.61h16.46c.34,0,.61-.27.61-.61v-34.14c0-6.78,4.72-11.38,11.62-11.38,6.42,0,10.65,4.47,10.65,11.13v34.39c0,.34.27.61.61.61h16.46c.34,0,.61-.27.61-.61v-34.14c0-6.78,4.72-11.38,11.63-11.38,6.42,0,10.65,4.47,10.65,11.13v34.39c0,.34.27.61.61.61h17.07v-40.33c0-13.79-8.96-22.88-22.4-22.88Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
}
